import { render, staticRenderFns } from "./ToxprintsCategories.vue?vue&type=template&id=155682af"
import script from "./ToxprintsCategories.vue?vue&type=script&lang=js"
export * from "./ToxprintsCategories.vue?vue&type=script&lang=js"
import style0 from "./ToxprintsCategories.vue?vue&type=style&index=0&id=155682af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports